module.exports = "/_next/static/images/6c7d3d18ac87699a9c5b82b6c7cd27f6-moneyboxes-left.jpg";